import React from 'react';
import { useParams } from 'react-router-dom';
import BookingBase from '../components/BookingBase';

function BookingDynamic() {
  const { slug } = useParams<{ slug: string }>();
  return <BookingBase boothSlug={slug || 'classic'} />;
}

export default BookingDynamic;
